import { equals } from 'ramda';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import Supercluster from 'supercluster';
import { setStopMarkerPopup } from '../../store/reducers/map';

const useCluster = ({ points = [], bounds, zoom }) => {
  const dispatch = useDispatch();
  const clusterRef = useRef();
  const pointsRef = useRef();
  const [clusters, setClusters] = useState([]);
  const zoomInt = useMemo(() => Math.round(zoom), [zoom]);
  const mapBounds = useMemo(() => bounds, [bounds]);

  useEffect(() => {
    if (!clusterRef.current || !equals(pointsRef.current, points)) {
      clusterRef.current = new Supercluster({ maxZoom: 20, extent: 1000 });
      clusterRef.current.load(points);
    }
    if (mapBounds) {
      const updated = clusterRef.current.getClusters(mapBounds, zoomInt);
      if (!equals(updated, clusters)) {
        dispatch(setStopMarkerPopup(null));
      }
      setClusters(
        points.length ? clusterRef.current.getClusters(mapBounds, zoomInt) : []
      );
    }

    pointsRef.current = points;
  }, [points, zoomInt, dispatch, mapBounds]);

  return { clusters, clusterRef: clusterRef.current };
};

export default useCluster;
